// extracted by mini-css-extract-plugin
module.exports = {"container":"_2NHqC8BJAw1KI3bhLjxOII"};